'use client'

import { PropsWithChildren } from 'react';
import Header from '../Components/Layout/Header';
import { useOrderTypeContext } from '../Contexts/OrderTypeContext';
import HeaderStoreCounter from '../Components/Layout/HeaderStoreCounter';
import FooterStoreCounter from '../Components/Layout/FooterStoreCounter';
import { useStoreContext } from '../Contexts/StoreContext';
import { ImSpinner8 } from 'react-icons/im';
import Footer from '../Components/Layout/Footer';
import { useLocation } from 'react-router-dom';
import { useStoreHook } from '../Hooks/StoreHook';

interface DefaultLayoutProps {
  categories?: any;
  showHeader?: boolean;
}

const DefaultLayout = ({
  children,
  categories,
  showHeader = true
}: PropsWithChildren<DefaultLayoutProps>) => {

  const { isStoreCounter } = useOrderTypeContext();
  const { loadingStore, cashier } = useStoreContext();

  const { getLinkToHome } = useStoreHook();

  const location = useLocation();
  const isHome = location.pathname === getLinkToHome();

  return (
    <>
      <div className={`
        flex flex-col min-h-dvh absolute w-full items-center
          ${isStoreCounter
              ? isHome && cashier ? 'pb-4' : 'pb-0'
              : isHome ? 'pb-20 md:pb-0' : 'pb-14 md:pb-0'
          }
        `}>

        {showHeader && (
          isStoreCounter
            ? <HeaderStoreCounter categories={categories} />
            : <Header categories={categories} />
        )}

        {/* CONTAINER */}
        <section className='flex flex-col flex-grow w-full md:max-w-[1460px]'>
          {/* CONTENT */}
          <section className='flex flex-grow p-3 md:p-6 lg:p-8 transition-width ease-in-out duration-200'>
            <div className='grid w-full gap-8 md:gap-12'>
              {loadingStore
                ?
                  <div className="flex flex-col gap-1 items-center justify-center text-sm text-gray-500 max-h-full min-h-96">
                    <div className="flex items-center gap-1"><ImSpinner8 className="animate-spin" /> <span>Carregando...</span></div>
                  </div>
                : children
              }
            </div>
          </section>
        </section>

        {/* FOOTER */}
        {isStoreCounter
          ? <FooterStoreCounter />
          : <Footer />
        }
      </div>
    </>
  )
}

export default DefaultLayout;